/*
 * Copyright (c) 2022 Robert J Whelton. All rights reserved.
 */
import * as React from "react"
import {SvgIcon as MuiSvgIcon, SvgIconProps, styled} from "@mui/material"

const SvgIcon = styled(MuiSvgIcon, {
  name: "LogoIcon",
  shouldForwardProp: (prop) => prop !== "fill",
})<SvgIconProps>(({theme}) => ({
  fill: theme.palette.primary.contrastText,
  stroke: theme.palette.primary.contrastText,
}))

SvgIcon.defaultProps = {
  // viewBox: "0 0 24 24",
  focusable: "false",
  preserveAspectRatio: "none",
}

const LogoIcon: React.FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <defs id="defs1577"><filter id="filter40240" x="-.046038" y="-.051056" width="1.113" height="1.1127" colorInterpolationFilters="sRGB"><feFlood id="feFlood40230" floodColor="rgb(242,242,242)" result="flood"/><feComposite
        id="feComposite40232" in="flood" in2="SourceGraphic" operator="in" result="composite1"/><feGaussianBlur
        id="feGaussianBlur40234" in="composite1" result="blur" stdDeviation="4"/><feOffset id="feOffset40236" dx="2"
                                                                                           dy="2" result="offset"/><feComposite
        id="feComposite40238" in="SourceGraphic" in2="offset" result="fbSourceGraphic"/><feColorMatrix
        id="feColorMatrix40242" in="fbSourceGraphic" result="fbSourceGraphicAlpha"
        values="0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"/><feFlood id="feFlood40244" floodColor="rgb(242,242,242)"
                                                                      in="fbSourceGraphic" result="flood"/><feComposite
        id="feComposite40246" in="flood" in2="fbSourceGraphic" operator="in" result="composite1"/><feGaussianBlur
        id="feGaussianBlur40248" in="composite1" result="blur" stdDeviation="4"/><feOffset id="feOffset40250" dx="2"
                                                                                           dy="2" result="offset"/><feComposite
        id="feComposite40252" in="fbSourceGraphic" in2="offset" result="composite2"/></filter></defs>
      <g id="g40033" transform="matrix(.054024 0 0 .054024 .54621 .48434)" filter="url(#filter40240)" stroke="#000"><g strokeWidth="2.4885"><path id="path805" d="m300.58 398.6 15.614-10.843-153.98-157.01z" fill="#808080" stopColor="#000000" stroke="#000" /><path
        id="path799" d="m219.04 396.87 16.048-6.9398-93.253-139.23z" fill="#666" stopColor="#000000" stroke="#000"
        /><g id="g3649" fill="#b3b3b3"><path id="path815" d="m235.52 389.93 27.592 18.637-44.942-10.829z" fill="#808080" stopColor="#000000" stroke="#000" strokeWidth="2.4885" /></g></g>
        <g stroke="#000"><path id="path817" d="m242.93 403.77-49.404 5.9047 24.769-12.147z" fill="#808080" stopColor="#000000" strokeWidth="2.4885" />
          <g strokeWidth="3.871"><path id="path803" d="m278.89 315.33 0.63545 35.032-18.563-0.47754z" stopColor="#000000" strokeLinejoin="bevel" />
            <path id="path807" d="m278.46 315.76-17.349 33.769-28.627-33.769z" fill="#333" stopColor="#000000"
                  />
            <path id="path795" d="m208.63 327.04 2.437 27.791-12.603 2.4821z" stopColor="#000000"
                  strokeLinejoin="bevel" />
            <path id="path801" d="m208.19 324.87-9.5212 32.437-29.949-29.401z" fill="#333" stopColor="#000000"
                  /></g></g>
        <g fill="#1a1a1a" stroke="#000" strokeWidth="3.871"><path id="path789" d="m342.14 239.39-60.648 76.37-44.72-0.88241z" stopColor="#000000" />
          <path id="path791" d="m339.62 240.72-118.41 84.579-49.49 4.483z" stopColor="#000000"
                />
          <path id="path793" d="m339.62 240.29-195.18 104.1 16.916-56.386z" stopColor="#000000"
                /></g>
        <g fill="#333" stroke="#000" strokeWidth="3.871"><path id="path783" d="m202.99 176.96-197.35 232.92 41.639 1.3012z" stopColor="#000000" />
          <path id="path785" d="m203.86 177.83-161.78 241.16 39.904-7.8073z" stopColor="#000000"
                />
          <path id="path787" d="m203.86 176.96-125.78 242.46 40.771-6.9398z" stopColor="#000000"
                /></g>
        <g id="g3657" stroke="#000"><path id="path781" d="m204.6 177.2-178.14 219.24 263.71-167.86z" fill="#4d4d4d" stopColor="#000000" strokeWidth="3.871" />
          <path id="path3653" d="m30.762 388.3 4.2104 4.7689-16.67 10.569z" stopColor="#000000"
                strokeLinecap="round" strokeLinejoin="round" strokeWidth=".26458"
                /></g>
        <g stroke="#000" strokeWidth="3.871"><path id="path779" d="m202.99 177.4-189.7 190.41 226.57-151.8z" fill="#4d4d4d" stopColor="#000000" />
          <path id="path747" d="m265.45 42.072-26.892 60.289 84.145-25.59z" fill="#333" stopColor="#000000"
                />
          <path id="path622" d="m351.2 12.62-12.923 29.886 67.633-12.075z" fill="#333" stopColor="#000000"
                strokeLinejoin="bevel" />
          <path id="path628" d="m405.52 30.824 14.743 24.88-41.167-19.706z" stopColor="#000000"
                />
          <path id="path630" d="m337.06 43.677 71.143 6.0701-25.6-14.582z" fill="#1a1a1a" stopColor="#000000"
                />
          <path id="path737" d="m351.41 12.36-28.281 63.977-48.639-14.193s68.678-46.748 76.919-49.784z" fill="#262626"
                stopColor="#000000" strokeLinejoin="bevel" />
          <path id="path739" d="m347.86 12.898-75.037 50.861-19.952-16.916s92.82-33.945 94.989-33.945z" fill="#333"
                stopColor="#000000" />
          <path id="path743" d="m338.84 40.903 28.148 71.163-44.284-35.729z" fill="#1a1a1a" stopColor="#000000"
                strokeLinejoin="bevel" />
          <path id="path745" d="m339.58 43.548 36.338 3.7297-20.96 33.668z" fill="#1a1a1a" stopColor="#000000"
                />
          <path id="path749" d="m322.27 76.338-65.098 20.39 86.785 22.116z" fill="#404040" stopColor="#000000"
                strokeLinejoin="bevel" /></g>
        <circle id="path684" cx="317.18" cy="30.717" r="11.303" fillOpacity=".99" stroke="#000" strokeLinecap="round"
                strokeLinejoin="bevel" strokeWidth="3.871"/>
        <g stroke="#000"><g strokeWidth="3.871"><path id="path769" d="m154.41 185.64 2.6024 54.651 52.796-64.918z" fill="#666" stopColor="#000000" /><path
          id="path771" d="m94.168 313.46 95.555-113.45 53.603 17.291z" fill="#8c8c8c" stopColor="#000000"
          /><path id="path773"
                                                        d="m94.168 313.46 196.05-84.205-44.293-17.154z"
                                                        fill="#666" stopColor="#000000"
                                                        /></g>
          <path id="path775" d="m94.168 313.46 247.78-73.982-44.27-12.904z" fill="#4d4d4d" stopColor="#000000"
                strokeLinejoin="bevel" strokeWidth="3.871" />
          <path id="path755" d="m259.04 96.327-69.158 104.49 152.28-81.122s-81.39-23.37-83.125-23.37z" fill="#737373"
                stopColor="#000000" strokeLinejoin="bevel" strokeWidth="3.871"
                />
          <g><g strokeWidth="3.871"><path id="path759" d="m341.35 119.71-92.502 103.35-57.688-22.386z" fill="#999" stopColor="#000000" /><path
            id="path761" d="m342.22 119.71-48.872 113.79-37.441-17.504z" fill="#808080" stopColor="#000000"
            /><path id="path763"
                                                          d="m343.52 119.28-13.638 121.32-33.206-14.188z"
                                                          fill="#666" stopColor="#000000"
                                                          /><path
            id="path765" d="m343.13 118.06 29.018 58.036-42.25 65.671z" fill="#4d4d4d" stopColor="#000000"
            /><path id="path777"
                                                          d="m371.12 177.78-28.873 61.205-13.072 4.0399z"
                                                          fill="#4d4d4d" stopColor="#000000"
                                                          /><path
            id="path741" d="m348.85 12.119-46.217-9.6945-50.902 44.696z" fill="#404040" stopColor="#000000"
            /></g>
            <g strokeWidth="2.4885"><path id="path811" d="m301.01 398.6-47.724 10.723 37.314-22.867z" fill="#b3b3b3" stopColor="#000000" />
              <path id="path813" d="m274.56 404.57-24.377 14.086 3.4614-9.3745z" fill="#ccc" stopColor="#000000"
                    />
              <path id="path819" d="m206.23 402.73-16.398-1.7602-3.0509 12.944z" fill="#ccc" stopColor="#000000"
                    /></g></g></g>
        <g id="g2899" stroke="#000"><path id="path751" d="m322.27 76.338 51.615 103.66-6.9398-67.663z" fill="#333" stopColor="#000000" strokeWidth="3.871" />
          <path id="path2829" d="m374.59 171.97-6.4931-0.0955 9.0712 18.906z" stopColor="#000000"
                strokeWidth=".26458" /></g>
        <g id="g3637" stroke="#000"><path id="path767" d="m155.01 185.21-75.64 98.458 77.475-47.323z" fill="#4d4d4d" stopColor="#000000" strokeWidth="3.871" />
          <path id="path3633" d="m82.172 277.24 3.7783 4.4054-13.9 8.5576z" stopColor="#000000" strokeWidth=".26458"
                /></g>
        <g id="g3631" stroke="#000"><path id="path3627" d="m139.51 183.35 2.4054 5.8971-13.501 2.4054z" stopColor="#000000" strokeWidth=".26458" />
          <path id="path757" d="m258.63 96.289-123.31 92.386 69.832-12.145z" fill="#4d4d4d" stopColor="#000000"
                strokeWidth="3.871" /></g>
        <g id="g3645" stroke="#000"><path id="path809" d="m315.76 387.76 39.968 28.052-56.45-16.775z" fill="#b3b3b3" stopColor="#000000" strokeWidth="2.4885" />
          <path id="path3639" d="m352.75 412.44 10.065 7.0314-11.663-4.0828z" stopColor="#000000"
                strokeLinecap="round" strokeLinejoin="round" strokeWidth=".2765"
                /></g>
        <path id="path3651" d="m13.004 365.65 1.4443 3.4568-14.234 9.3393z" stopColor="#000000" stroke="#000"
              strokeLinecap="round" strokeLinejoin="round" strokeWidth=".2765"
              />
        <path id="path2101" d="m325.46 27.802-13.56-0.97333-3.3129 7.2642z" fill="#f2f2f2" stopColor="#000000"
              stroke="none" /></g>
    </SvgIcon>
  )
}

export default LogoIcon
